/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "application_flow": {
                "nested": {
                  "PhoneNumber": {
                    "fields": {
                      "value": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "verificationStatus": {
                        "type": ".squareup.corporate_card.resources.application_flow.PhoneNumber.VerificationStatus",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "VerificationStatus": {
                        "values": {
                          "PN_VS_DO_NOT_USE": 0,
                          "PENDING": 1,
                          "SMS_REQUESTED": 2,
                          "SMS_SENT": 3,
                          "VERIFIED": 4,
                          "FAILED": 5
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.PhoneNumber && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.PhoneNumber?.nested?.VerificationStatus) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A phone number associated with a corporate-card application flow
 * --
 *
 * SOURCE PhoneNumber @ squareup/corporate_card/resources/application_flow/phone_number.proto at 10:1
 */
export const PhoneNumber = $root.lookupType('squareup.corporate_card.resources.application_flow.PhoneNumber');
fixType(PhoneNumber);
Builder.createAndAttachToType(PhoneNumber);
/**
 * SOURCE VerificationStatus @ squareup/corporate_card/resources/application_flow/phone_number.proto at 11:3
 */
PhoneNumber.VerificationStatus = $root.lookupEnum('squareup.corporate_card.resources.application_flow.PhoneNumber.VerificationStatus').values;